var React = require('react');

function Nodes (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("rect",{"width":"64","height":"64","rx":"4"})),React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#fff","stroke":"#1B68FF","strokeWidth":"12","mask":"url(#a)","key":1}),React.createElement("path",{"d":"M40.06 38.62c-1.21 0-2.3.48-3.14 1.24l-11.44-6.67c.08-.37.15-.74.15-1.13 0-.38-.07-.75-.15-1.12l11.31-6.6a4.79 4.79 0 008.09-3.52 4.81 4.81 0 10-9.48 1.12l-11.31 6.6A4.79 4.79 0 0016 32.07a4.81 4.81 0 008.09 3.52l11.42 6.69a4.7 4.7 0 104.56-3.65z","fill":"#1B68FF","key":2})]);
}

Nodes.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = Nodes;

Nodes.default = Nodes;
